import { useState } from "react";

import type { VolumeUnit } from "../../types";

export type VolumeConverterSelection = {
  pending: VolumeUnit;
  setPending: (unit: VolumeUnit) => void;
  saveAsDefault: boolean;
  setSaveAsDefault: (saveAsDefault: boolean) => void;
};

export const useVolumeConverterSelection = (
  value: VolumeUnit,
): VolumeConverterSelection => {
  const [pending, setPending] = useState<VolumeUnit>(value);
  const [saveAsDefault, setSaveAsDefault] = useState(false);

  return { pending, setPending, saveAsDefault, setSaveAsDefault };
};
